import { QUIZ } from '~/consts';
import modal from "~/utils/modal";

export const state = () => ({
  run: null,
  lists: [],
  loading_get_lists: false,
  loading_save_quiz: false,
  loading_start_quiz: false,
  dataProvider: {
    criterion: [],
    page: {
      current: 1,
      limit: 0
    },
    sort: []
  },
  quizProctoring: {
    tncAggree: false,
    webcamAccess: 'idle',
    microphoneAccess: 'idle',
    screenAccess: 'idle',
    quiz: null,
    isReportFetched: false,
    isLogProcess: false,
    faceCount: 0,
    faceDetectCount: 0,
    faceUndetectCount: 0,
    faceDetectionsCount: 0,
    unfocusScreenCount: 0,
    mediasCount: 0,
  },
  sameDevice: {
    showWarning: false,
    uuid: null,
    quizMemberUuid: null,
    saveDeviceLoading: false,
    backDetailLoading: false,
  }
})

export const mutations = {
  setLoading(state, { key, val }) {
    state[key] = val;
  },
  setLists(state, val) {
    state.lists = val;
  },
  addToLists(state, val) {
    let items = Array.isArray(val) ? val : [val];

    state.lists = state.lists.concat(items);
  },
  setRunnedQuiz(state, val) {
    state.run = val;
  },
  setRunnedQuizQuestions(state, val) {
    state.run['questions'] = val;
  },
  setDataProvider(state, val) {
    state.dataProvider = val;
  },
  setProctoring(state, { key, value }) {
    state.quizProctoring[key] = value;
  },
  setSameDevice(state, { key, value }) {
    state.sameDevice[key] = value;
  }
}

export const actions = {
  async getLists({ commit, state }, refresh = false) {
    const vm = this;

    if (!state.loading_get_lists) {
      commit('setLoading', {key: 'loading_get_lists', val: true});
      let dataProvider = _.cloneDeep(state.dataProvider);

      if (refresh) {
        dataProvider.page['current'] = 1;
      }

      const { data } = await this.$axios.post(QUIZ.GET_LISTS, {
        dataProvider: JSON.stringify(dataProvider)
      });

      if (data.applicationSystem.code == 0) {
        if (refresh) {
          commit('setLists', data.data.data);
        } else {
          commit('addToLists', data.data.data);
        }

        commit('setDataProvider', data.data.dataProvider);
      }

      commit('setLoading', {key: 'loading_get_lists', val: false});
    }
  },
  add({ commit, dispatch }) {
    commit('setLoading', { key: 'loading_save_quiz', val: true });

    this.$axios.post(QUIZ.ADD).then(({ data }) => {
      if (data.applicationSystem.code == 0) {
        toast.info(data.applicationSystem.message)
        this.$router.push(`/panel/quizes/${data.data.id}`);
      } else {
        toast.danger(data.applicationSystem.message);
      }

      commit('setLoading', { key: 'loading_save_quiz', val: false });
    }).catch(() => {
      commit('setLoading', { key: 'loading_save_quiz', val: false });
      Vue.nextTick(() => {
        modal.hide('#edit-question');
      });
    })
  },
  update({ commit, dispatch }, { id, data }) {
    commit('setLoading', { key: 'loading_save_quiz', val: true });

    this.$axios.post(QUIZ.UPDATE(id), data).then(({ data }) => {
      if (data.applicationSystem.code == 0) {
        dispatch('getLists', true);

        toast.info(data.applicationSystem.message)
        this.$router.push(`/panel/quizes`);
      } else {
        toast.danger(data.applicationSystem.message)
      }

      commit('setLoading', { key: 'loading_save_quiz', val: false });
      Vue.nextTick(() => {
        modal.hide('#edit-question');
      });
    }).catch(() => {
      commit('setLoading', { key: 'loading_save_quiz', val: false });
      Vue.nextTick(() => {
        modal.hide('#edit-question');
      });
    })
  },
  getRunnedQuiz ({ commit, dispatch }) {
    this.$axios.post(QUIZ.RUNNED_QUIZ)
      .then(({ data }) => {
        if (data.applicationSystem.code == 0) {
          commit('setRunnedQuiz', data.data);
        }
      }).
      catch(({ response }) => {

      })
  },
  startQuiz({ commit }, quiz_id) {
    commit('setLoading', {key: 'loading_start_quiz', val: true});

    this.$axios.post(QUIZ.START(quiz_id))
      .then(({ data }) => {
        if (data.applicationSystem.code == 0) {
          if (!helpers.isEmpty(data.data) && !helpers.isEmpty(data.data.id)) {
            let group_type = data.data.groupType == 'A' ? 'classes' : 'groups';

            this.$router.push({ path: `/panel/${group_type}/${data.data.groupId}/sections/${data.data.sectionId}/${data.data.lmId}` });
          } else {

            if (data.data.sameDevice) {
              this.$router.push( { path: `/quiz/${data.data.uuid}`, query: { quizMemberUuid: data.data.quizMemberUuid, withoutMobileApps: 1 } });
            } else {
              commit('setSameDevice', { key: 'showWarning', value: true });
              commit('setSameDevice', { key: 'uuid', value: data.data.uuid });
              commit('setSameDevice', { key: 'quizMemberUuid', value: data.data.quizMemberUuid });
            }

          }
        } else {
          toast.danger(data.applicationSystem.message);
        }

        commit('setLoading', {key: 'loading_start_quiz', val: false});
      })
      .catch(({ response }) => {
        commit('setLoading', {key: 'loading_start_quiz', val: false});
      });
  },
  logCheatOpportunity({ commit }, id) {
    this.$axios.post(QUIZ.TRACK_FOCUS_TAB(id))
      .then(({ data }) => {
      })
      .catch(({ response }) => {
      });
  },
  async fetchProctoringReport({ commit }, quizMemberUuid) {

    commit('setProctoring', { key: 'isReportFetched', value: false });
    commit('setProctoring', { key: 'faceCount', value: 0 });
    commit('setProctoring', { key: 'faceDetectCount', value: 0 });
    commit('setProctoring', { key: 'faceUndetectCount', value: 0 });
    commit('setProctoring', { key: 'faceDetectionsCount', value: 0 });
    commit('setProctoring', { key: 'unfocusScreenCount', value: 0 });
    commit('setProctoring', { key: 'mediasCount', value: 0 });

    try {
      const { data } = await this.$axios.post(QUIZ.PROCTORING_REPORT_RESULT, { quiz_member_uuid: quizMemberUuid });

      if (data.applicationSystem.code == 0) {
        const report = data.data;

        if (!helpers.isEmpty(report)) {
          commit('setProctoring', { key: 'faceCount', value: report.faceCount });
          commit('setProctoring', { key: 'faceDetectCount', value: report.faceDetectCount });
          commit('setProctoring', { key: 'faceUndetectCount', value: report.faceUndetectCount });
          commit('setProctoring', { key: 'faceDetectionsCount', value: report.faceDetectCount + report.faceUndetectCount });
          commit('setProctoring', { key: 'unfocusScreenCount', value: report.unfocusScreenCount });
          commit('setProctoring', { key: 'mediasCount', value: report.mediasCount });
        }
      }

      commit('setProctoring', { key: 'isReportFetched', value: true });
    } catch (error) {
      commit('setProctoring', { key: 'isReportFetched', value: true });
    }
  },
  logProctoringReport({ commit, state }, quizMemberUuid) {
    commit('setProctoring', { key: 'isLogProcess', value: true });

    this.$axios.post(QUIZ.PROCTORING_SAVE, {
      quiz_member_uuid: quizMemberUuid,
      face_detect_count: state.quizProctoring.faceDetectCount,
      face_undetect_count: state.quizProctoring.faceUndetectCount,
      face_count: state.quizProctoring.faceCount,
      unfocus_screen_count: state.quizProctoring.unfocusScreenCount,
    })
      .then(({ data }) => {
        commit('setProctoring', { key: 'isLogProcess', value: false });
      })
      .catch(({ response }) => {
        commit('setProctoring', { key: 'isLogProcess', value: false });
      });
  },
  async saveDevice({ commit, state }) {
    commit('setSameDevice', { key: 'saveDeviceLoading', value: true });

    try {
      const { data } = await this.$axios.post(QUIZ.SAVE_DEVICE, { quiz_member_uuid: state.sameDevice.quizMemberUuid });

      if (data.applicationSystem.code == 0) {
        commit('setSameDevice', { key: 'showWarning', value: false });
        commit('setSameDevice', { key: 'saveDeviceLoading', value: false });
        this.$router.push( { path: `/quiz/${state.sameDevice.uuid}`, query: { quizMemberUuid: state.sameDevice.quizMemberUuid, withoutMobileApps: 1 } });
      } else {
        toast.danger('Terjadi kesalahan saat menyimpan perangkat kuis');
        commit('setSameDevice', { key: 'saveDeviceLoading', value: false });
      }
    } catch (error) {
      toast.danger('Terjadi kesalahan saat menyimpan perangkat kuis');
    }
  }
}
